module.exports = __webpack_public_path__ + "img/wchgz-text.2b56c496.png";